module.exports = __webpack_public_path__ + "img/stock2.d05d8624.png";